var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import './Typer.scss';
/**
 * Typer component
 */
var Typer = /** @class */ (function (_super) {
    __extends(Typer, _super);
    /**
     * Typer constructor
     *
     * @param props
     */
    function Typer(props) {
        var _this = _super.call(this, props) || this;
        _this.getNextLinkIndex = function () {
            if (_this.checkNextListIndexExist()) {
                return _this.state.currentLinkIndex + 1;
            }
            return 0;
        };
        /**
         * Check id current link index need to be updated
         * @param nextLinkIndex
         * @param state
         */
        _this.checkIfCurrentLinkIndexNeedToBeUpdated = function (nextLinkIndex, state) {
            var _a = _this.state, currentLinkIndex = _a.currentLinkIndex, deleteMode = _a.deleteMode;
            return nextLinkIndex !== currentLinkIndex && (deleteMode && deleteMode !== state.deleteMode);
        };
        /**
         * Check if next step is delete mode
         */
        _this.checkNextIsDeleteMode = function () {
            var _a = _this.state, deleteMode = _a.deleteMode, cursorPosition = _a.cursorPosition;
            if (deleteMode && cursorPosition > 0) {
                return _this.getNextCursorPosition() >= 0;
            }
            return _this.getNextCursorPosition() < cursorPosition;
        };
        _this.checkNextListIndexExist = function () {
            return !!_this.props.list[_this.state.currentLinkIndex + 1];
        };
        _this.checkNextCharacterExist = function (nextIndex) {
            var sign = _this.state.deleteMode ? -1 : 1;
            return !!_this.props.list[_this.state.currentLinkIndex].title[nextIndex - sign];
        };
        /**
         * Build state
         */
        _this.buildState = function (nextCursorPosition, nextLinkIndex) {
            var state = {
                animateCursor: false,
                currentLinkIndex: 0,
                cursorPosition: 0,
                deleteMode: false,
            };
            if (_this.checkNextIsDeleteMode()) {
                state.deleteMode = true;
                state.cursorPosition = nextCursorPosition;
            }
            else {
                state.deleteMode = false;
                state.cursorPosition = nextCursorPosition;
            }
            if (_this.checkIfCurrentLinkIndexNeedToBeUpdated(nextLinkIndex, state)) {
                state.currentLinkIndex = nextLinkIndex;
            }
            return state;
        };
        /**
         * Return delta time
         */
        _this.getDeltaTime = function () {
            var delta = Math.random() * 100;
            if (_this.state.deleteMode) {
                delta /= 4;
            }
            return delta;
        };
        _this.getNextCursorPosition = function () {
            var _a = _this.state, deleteMode = _a.deleteMode, cursorPosition = _a.cursorPosition;
            var sign = deleteMode ? -1 : 1;
            if (_this.checkNextCharacterExist(cursorPosition + sign)) {
                return cursorPosition + sign;
            }
            return cursorPosition + sign * -1;
        };
        /**
         * Return the next display delay
         */
        _this.getNextDelay = function () {
            if (_this.state.cursorPosition === _this.props.list[_this.state.currentLinkIndex].title.length) {
                return Typer.timeForDisplaySentence;
            }
            if (_this.state.cursorPosition === 0) {
                return Typer.timeWaitingNextSentence;
            }
            return _this.getDeltaTime();
        };
        _this.state = {
            animateCursor: false,
            currentLinkIndex: 0,
            cursorPosition: 0,
            deleteMode: false,
        };
        return _this;
    }
    /**
     * Component initialization
     */
    Typer.prototype.componentDidMount = function () {
        if (this.props.list.length) {
            this.tick();
        }
    };
    /**
     * component destruction
     */
    Typer.prototype.componentWillUnmount = function () {
        clearTimeout(this.timeout);
    };
    Typer.prototype.render = function () {
        var _a = this.state, currentLinkIndex = _a.currentLinkIndex, cursorPosition = _a.cursorPosition;
        return this.props.list[currentLinkIndex] ? (React.createElement("a", { className: "typer", href: this.props.list[currentLinkIndex].url, target: "_blank", rel: "noopener" },
            this.props.list[currentLinkIndex].title.substring(0, cursorPosition),
            React.createElement("span", { className: "blink" }, "|"))) : null;
    };
    /**
     * Write text animation
     */
    Typer.prototype.tick = function () {
        var _this = this;
        var nextCursorPosition = this.getNextCursorPosition();
        var delay = this.getNextDelay();
        var nextLinkIndex = this.getNextLinkIndex();
        var state = this.buildState(nextCursorPosition, nextLinkIndex);
        if (this.checkNextIsDeleteMode()) {
            state.deleteMode = true;
            state.cursorPosition = nextCursorPosition;
        }
        else {
            state.deleteMode = false;
            state.cursorPosition = nextCursorPosition;
        }
        if (this.checkIfCurrentLinkIndexNeedToBeUpdated(nextLinkIndex, state)) {
            state.currentLinkIndex = nextLinkIndex;
        }
        this.timeout = window.setTimeout(function () {
            _this.setState(state);
            clearTimeout(_this.timeout);
            _this.tick();
        }, delay);
    };
    Typer.timeForDisplaySentence = 5000;
    Typer.timeWaitingNextSentence = 1000;
    return Typer;
}(React.Component));
export default Typer;
//# sourceMappingURL=Typer.js.map